<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.contract_pdf') }}</h5>
    </template>

    <b-row>
      <b-col md="6">
        <o-form-group :label="$t('sandoz.contract_version')">
          <b-form-input v-model="item.contract_version" :readonly="readonly"/>
        </o-form-group>

        <o-form-group :label="$t('sandoz.payment_schema')">
          <b-form-select v-model="item.payment_schema" :options="paymentSchemas" :disabled="readonly"/>
        </o-form-group>
      </b-col>
      <b-col md="6">
        <h6>{{ $t('sandoz.contract_partners') }}</h6>
        <div v-for="i in 7" :key="i" class="form-row align-items-center mb-1">
          <div class="col">
            <b-form-input :placeholder="$t('sandoz.partner_name') + ' ' + i"
                          :value="item['contract_partner_' + i]"
                          @input="$set(item, 'contract_partner_' + i, $event)"
                          :readonly="readonly"/>
          </div>
          <div class="col">
            <b-form-input :placeholder="$t('sandoz.partner_title') + ' ' + i"
                          :value="item['contract_partner_' + i + '_title']"
                          @input="$set(item, 'contract_partner_' + i + '_title', $event)"
                          :readonly="readonly"/>
          </div>
        </div>
      </b-col>
    </b-row>

    <hr/>

    <div class="btn-group" v-if="!readonly">
      <b-btn variant="primary" @click="generatePdf" :disabled="busy">
        <b-spinner v-if="busy" small/>
        <fa v-else icon="file-pdf"/>
        {{ $t('sandoz.generate_pdf') }}
      </b-btn>
      <b-btn variant="secondary" @click="generateDocx('discount')">
        <fa icon="file-word"/> {{ $t('sandoz.generate_docx_discount') }}
      </b-btn>
      <b-btn variant="secondary" @click="generateDocx('network')">
        <fa icon="file-word"/> {{ $t('sandoz.generate_docx_network') }}
      </b-btn>
    </div>

    <h6 class="mt-3">{{ $t('sandoz.pdf_history') }}</h6>
    <table v-if="pdfHistory.length" class="table table-sm">
      <thead>
        <tr>
          <th>{{ $t('sandoz.version') }}</th>
          <th>{{ $t('sandoz.created_at') }}</th>
          <th>{{ $t('sandoz.file') }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pdf in pdfHistory" :key="pdf.id">
          <td>{{ pdf.version || pdf.contract_version }}</td>
          <td>{{ pdf.created_at }}</td>
          <td>{{ pdf.name || pdf.filename }}</td>
          <td>
            <a v-if="pdf.url || pdf.path" :href="pdf.url || pdf.path" target="_blank">
              <fa icon="download"/>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else class="text-muted">{{ $t('sandoz.no_pdfs_yet') }}</p>
  </o-card>
</template>

<script>
import axios from 'axios'
import sectionMixin from '../sectionMixin'

/**
 * Contract PDF generation, signing and history. Source: kam/ContractDetail.vue.
 *
 * The generate-pdf2 / docx endpoints are the same ones the legacy detail uses — this section
 * just calls them with the current contract id.
 */
export default {
  name: 'SectionPdf',
  mixins: [sectionMixin],
  data() {
    return {
      busy: false,
      paymentSchemas: [
        { value: null, text: '-' },
        'yearly', 'quarterly', 'monthly', 'on_delivery'
      ].map(v => typeof v === 'string' ? { value: v, text: v } : v)
    }
  },
  computed: {
    pdfHistory() {
      return Array.isArray(this.item.pdfs) ? this.item.pdfs : []
    }
  },
  methods: {
    async generatePdf() {
      this.busy = true
      try {
        const resp = await axios.post('/api/sandoz/generate-pdf2', { id: this.item.id }, { responseType: 'arraybuffer' })
        const blob = new Blob([resp.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${this.item.contract_no || 'contract'}.pdf`
        a.click()
        window.URL.revokeObjectURL(url)
      } finally {
        this.busy = false
      }
    },
    async generateDocx(type) {
      const url = `/api/sandoz/kam/contracts/${this.item.id}/${type}/docx`
      window.open(url, '_blank')
    }
  }
}
</script>
